import Container from 'components/Container'
import { useIntegrationsTab } from './hooks'
import Styled from './styled'
import Loader from 'components/Loader'
import { Button } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'

const IntegrationsTab = () => {
	const { widgetLoaded, error, setError, t } = useIntegrationsTab()

	return (
		<Container
			display="flex"
			flexDirection="column"
			space="sm"
			spaceDirection="vertical"
			min={{ height: 200 }}
			justifyContent="center"
		>
			{!widgetLoaded && !error && <Loader />}

			<Styled.ErrorContainer
				style={!error ? { display: 'none' } : undefined}
				title={
					<>
						<CloseCircleOutlined />
						{t('terms.error')}
					</>
				}
				subTitle={t('integrations.new.error.subtitle')}
				extra={
					<Button type="primary" onClick={() => setError(null)}>
						{t('actions.retry')}
					</Button>
				}
			/>

			<Styled.VezgoContainer
				style={error ? { display: 'none' } : undefined}
				name="vezgo-connect-widget"
				$loaded={widgetLoaded}
			></Styled.VezgoContainer>
		</Container>
	)
}

export default IntegrationsTab
